import NotificationService from './notificationService';

// 模拟产品更新数据
const mockUpdates = [
  {
    id: '1',
    version: '1.1.0',
    title: '新功能: 批量许可证生成',
    description: '现在您可以一次生成多个许可证，提高工作效率。',
    releaseDate: '2023-06-01',
    importance: 'major',
    link: '#/updates/1.1.0'
  },
  {
    id: '2',
    version: '1.0.5',
    title: '新增: 许可证导出功能',
    description: '您现在可以将许可证导出为CSV或JSON格式。',
    releaseDate: '2023-05-15',
    importance: 'minor',
    link: '#/updates/1.0.5'
  },
  {
    id: '3',
    version: '1.1.1',
    title: '安全更新: 增强账户保护',
    description: '我们提升了系统的安全性，增加了账户锁定机制。',
    releaseDate: '2023-06-10',
    importance: 'security',
    link: '#/updates/1.1.1'
  }
];

// 检查产品更新
const checkUpdates = () => {
  return new Promise((resolve) => {
    // 模拟网络延迟
    setTimeout(() => {
      const lastShownUpdate = localStorage.getItem('lastShownUpdateId');
      const availableUpdates = mockUpdates.filter(update => 
        update.id !== lastShownUpdate
      );
      
      resolve(availableUpdates);
    }, 1500);
  });
};

// 标记更新已显示
const markUpdateAsShown = (updateId) => {
  localStorage.setItem('lastShownUpdateId', updateId);
};

// 开始检查更新的轮询
const startUpdatePolling = (intervalMinutes = 60) => {
  // 立即检查一次更新
  checkForUpdates();
  
  // 设置定时器，定期检查更新
  const intervalId = setInterval(checkForUpdates, intervalMinutes * 60 * 1000);
  return intervalId;
};

// 检查更新并显示通知
const checkForUpdates = async () => {
  try {
    const updates = await checkUpdates();
    
    if (updates.length > 0) {
      // 获取最新的更新
      const latestUpdate = updates[0];
      
      // 显示通知
      NotificationService.showUpdateNotification({
        title: latestUpdate.title,
        description: latestUpdate.description,
        link: latestUpdate.link
      });
      
      // 标记此更新已显示
      markUpdateAsShown(latestUpdate.id);
    }
  } catch (error) {
    // console.error('检查更新失败:', error);
  }
};

export const UpdateService = {
  checkUpdates,
  startUpdatePolling,
  stopUpdatePolling: (intervalId) => clearInterval(intervalId)
};

export default UpdateService;
